
import React, { Suspense, lazy } from "react";
import { Toaster } from "@/lib/vendor/toaster";
import { Toaster as Sonner } from "@/lib/vendor/sonner";
import { TooltipProvider } from "@/lib/vendor/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import NotFound from "./pages/NotFound";
import { useFaviconPersonality } from "@/hooks/useFaviconPersonality";

const Index = lazy(() => import("./pages/Index"));
const Contact = lazy(() => import("./pages/Contact"));

const queryClient = new QueryClient();

const App = () => {
  useFaviconPersonality();

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
          <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading…</div>}>
                <Index />
              </Suspense>
            } />
            <Route path="/contact" element={
              <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading…</div>}>
                <Contact />
              </Suspense>
            } />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Analytics />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
